import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { loadConfigurationByPrStringApiUrl } from '../../../constants/apiUrls'
import { ApiRequest } from '../../apiRequest'
import {
    loadConfigurationByPrString,
    loadConfigurationByPrStringAsync, resetPrStringStatusState, setPrStringStatusState,
} from '../../actions/app/prString.actions'
import { fetchConfiguration } from '../../actions/app/configuration.actions'
import { fetchCart } from '../../actions/app/cart.actions'
import { fetchEquipmentGroups } from '../../actions/app/equipmentGroups.actions'
import { fetchVisualization } from '../../actions/app/visualization.actions'
import { setShouldNavigateToTarget } from '../../actions/app/navigation.actions'
import isVwnRecommendationsEnabledSelector from '../../selectors/feature-scope/isVwnRecommendationsEnabledSelector'
import { fetchVwnModelsWithRecommendations } from '../../actions/app/vwnRecommendation.actions'

const prStringMiddleware =
    (apiRequest: ApiRequest): Middleware => (store) => (next) => (action) => {
        next(action)
        const { dispatch, getState } = store

        if (isActionOf(loadConfigurationByPrString, action)) {
            const prString = action.payload

            apiRequest(
                {
                    options: {
                        url: loadConfigurationByPrStringApiUrl(decodeURI(prString)),
                        method: 'POST',
                    },
                    asyncActions: loadConfigurationByPrStringAsync,
                    causedBy: action,
                },
                dispatch,
            )
        }

        if (isActionOf(loadConfigurationByPrStringAsync.success, action)) {
            const { status, alternatives } = action.payload
            const state = getState()
            const isVwnRecommendationsEnabled = isVwnRecommendationsEnabledSelector(state)

            if (alternatives) {
                dispatch(setShouldNavigateToTarget(false))
                dispatch(setPrStringStatusState(action.payload))
            }

            if (status === 'OK' && alternatives === null) {
                dispatch(fetchConfiguration())
                dispatch(fetchCart())
                dispatch(fetchEquipmentGroups())
                dispatch(fetchVisualization())
                dispatch(resetPrStringStatusState())
                dispatch(setShouldNavigateToTarget(true))

                if (isVwnRecommendationsEnabled) {
                    dispatch(fetchVwnModelsWithRecommendations())
                }
            }
        }
    }
export default prStringMiddleware
